<template>
  <div>
    <vs-prompt
      id="document-copy-dialog"
      @accept="copyDocuments"
      @cancel="cancel"
      @close="close"
      :color="AISEA_COLOR.BLUE"
      :active.sync="showDialog"
      :title="methodName"
      :accept-text="methodName"
      :cancel-text="cancelText"
      :is-valid="validatePath"
    >
      <select-path-template
        :targetDocments="copyTargetDocments"
        :methodName="methodName"
        :validate="() => {}"
      >
      </select-path-template>
    </vs-prompt>
  </div>
</template>

<script>
import SelectPathTemplate from "./components/DocumentSelectPathTemplate"
import { ColorMixin, DocumentMixin } from "@/mixins";
import { createNamespacedHelpers } from "vuex";

const {
  mapActions: mapActionsOfenterpriseDocumentManager,
  mapMutations: mapMutationsOfenterpriseDocumentManager,
  mapState: mapStateOfenterpriseDocumentManager
} = createNamespacedHelpers("enterpriseDocumentManager");

export default {
  mixins: [ColorMixin, DocumentMixin],
  components: { SelectPathTemplate },
  props: {
    copyTargetDocments: {
      type: Array,
      required: true,
      default: () => { return [] }
    },
  },
  data () {
    return {
      documentName: "",
      error: { message: null },
      showDialog: false,
      methodName: "コピー",
      cancelText: "キャンセル",
      duplicatedItems: [],
    };
  },
  computed: {
    ...mapStateOfenterpriseDocumentManager([
      "documentNewPath",
      "documentRootPath"
    ]),
    validatePath () {
      let validate = true
      const newFullPath = `${this.documentRootPath}${this.documentNewPath}`
      this.copyTargetDocments.forEach(item => {
        const srcPath = item.size ? item.path : `${item.path}/`

        //コピー先がコピー対象のフォルダ内に存在するフォルダの場合、コピーできない
        const isChildFolderPath = !item.size && newFullPath.startsWith(srcPath);

        if (isChildFolderPath) {
          validate = false
          return
        }

      })
      return validate
    },
  },
  methods: {
    ...mapActionsOfenterpriseDocumentManager([
      "copyFile",
      "copyFolder",
      "existsFile",
      "existsFolder"
    ]),
    ...mapMutationsOfenterpriseDocumentManager([
      "SET_SELECTED_MOVE_SOURCE",
      "SET_DOCUMENT_NEW_PATH",
      "SET_SELECTED_MOVE_DIAROG_FOLDER"
    ]),
    show () {
      this.showDialog = true;
      this.SET_DOCUMENT_NEW_PATH("")
      this.SET_SELECTED_MOVE_DIAROG_FOLDER("tree-root")
    },
    sourceDocumentIcon (document) {
      if (!document.type) return "FolderIcon"
      return this.getDocumentMimeIcon(document.type)
    },
    sourceDocumentName (name) {
      return name.replace(this.documentRootPath, "")
    },
    showCreateFolderDropdown () {
      this.$refs.DocumentCreateFolderDialog.show(this.documentNewPath)
    },
    async copyDocuments () {
      try {
        const destinationPath = `${this.documentRootPath}${this.documentNewPath}`;

        const folders = this.copyTargetDocments.filter(item => !("size" in item))
          .map(item => {
            return {
              "path": `${item.path}/`
            }
          });

        const files = this.copyTargetDocments.filter(item => "size" in item)
          .map(item => {
            return {
              "path": item.path
            }
          });

        this.$vs.loading();

        if (folders.length > 0) {
          const payload = {
            destination_folder: destinationPath,
            documents: folders
          };
          await this.copyFolder(payload)
        }

        if (files.length > 0) {
          const payload = {
            destination_folder: destinationPath,
            documents: files
          };
          await this.copyFile(payload)
        }

        this.$vs.loading.close();
        this.$vs.notify({
          title:
            `船舶書類の${this.methodName}が完了しました`,
          color: "success",
          iconPack: "feather",
          icon: "icon-check"
        });
        this.close();
      } catch (e) {
        console.error(e)
        this.$vs.notify({
          title: `船舶書類の${this.methodName}に失敗しました`,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger"
        });
        this.$vs.loading.close();
        this.close();
      }
    },

    close () {
      this.cleanUp();
    },

    cancel () {
      this.cleanUp();
    },

    cleanUp () {
      this.showDialog = false;
      this.duplicatedItems = [];
      this.$emit("copyDocuments", []);
      this.SET_DOCUMENT_NEW_PATH("")
      this.SET_SELECTED_MOVE_DIAROG_FOLDER("")
    }
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";

#document-copy-dialog {

  .vs-dialog {
    max-width: 600px;
  }

  z-index: 288;
}
</style>
